import React from 'react';
import './AppStoreGlyph.css';

// The App Store's "A" mark on a rounded tile. Colours come from the
// --app-store-glyph-tile and --app-store-glyph-mark custom properties, so
// each placement can invert it to suit its background.
const AppStoreGlyph = ({ className = '' }) => (
  <svg className={`app-store-glyph ${className}`.trim()} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect className="app-store-glyph__tile" x="1.5" y="1.5" width="21" height="21" rx="5.5" />
    <path className="app-store-glyph__mark" d="M7.7 17.3 12.9 8.3M11.1 8.3l5.2 9M6.6 14.8h10.8" />
  </svg>
);

export default AppStoreGlyph;
